"use client";
import { useEffect } from "react";
export default function Effect({ referrer }: { referrer: any }) {
  useEffect(() => {
    window.history.replaceState(null, "", referrer);
    window.ignore403Redirect = true; // 用于兼容axios里的接口请求403，将来可以删除
  }, []);
  return null;
}
